import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPercent = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5 9.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM9.5 7a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"
		}),
		/* @__PURE__ */ _jsx("path", { d: "m25.707 7.707-18 18a1 1 0 0 1-1.414-1.414l18-18a1 1 0 1 1 1.414 1.414Z" }),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M22.5 18a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9ZM20 22.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0Z"
		})
	]
});
export default SvgPercent;
